import { render } from "./BehfamLOGOEmpty.vue?vue&type=template&id=bee47e0a&scoped=true"
import script from "./BehfamLOGOEmpty.vue?vue&type=script&lang=js"
export * from "./BehfamLOGOEmpty.vue?vue&type=script&lang=js"

import "./BehfamLOGOEmpty.vue?vue&type=style&index=0&id=bee47e0a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bee47e0a"]])

export default __exports__